import { FILTERS_MAP } from '../../../constants';
import { algoliaStringFormatter } from '../../utils/algolia-string-formatter';
import { numberFilters } from '../../utils/number-filters';

interface CheckboxProps {
  routeStateRefinementList: Record<string, string[]>;
  href: string;
  categoryFiltersLabel?: { [key: string]: string };
}

interface AttributeDetails {
  prefix?: string;
  sufix?: string;
}

const checkbox = (props: CheckboxProps) => {
  const { routeStateRefinementList, href } = props;

  const numberFilter = numberFilters(href);

  const entries = Object.entries(routeStateRefinementList);

  const newUrl = new URL(href);

  const attributeDetails: AttributeDetails | null = (() => {
    const item = localStorage.getItem('@algolia/categories-attributes');
    return item ? JSON.parse(item) : null;
  })();

  const applyPrefixSufix = (value: string) => {
    if (attributeDetails?.prefix) return `${attributeDetails.prefix}_${value}`;
    if (attributeDetails?.sufix) return `${value}_${attributeDetails.sufix}`;
    return value;
  };

  const buildValue = (value: string) => {
    const formatted = value.replaceAll(' ', '_');
    return formatted.charAt(0).toUpperCase() + formatted.slice(1);
  };

  entries.forEach(([key, type]) => {
    const hasAttributePrefix = key.includes('attributes');

    const keyString = key.split('attributes.');

    const typeFilter = hasAttributePrefix
      ? algoliaStringFormatter(keyString[1])
      : FILTERS_MAP[key]?.toLowerCase();

    const reversedType = [...type].reverse();

    reversedType.forEach((value, index) => {
      const formattedValue = buildValue(value);
      const finalValue = applyPrefixSufix(formattedValue);

      const isFirstValue = index === 0 && numberFilter === 0;
      const isNotInHref = !href.includes(formattedValue);

      if (!isNotInHref) return;

      if (isFirstValue) {
        newUrl.pathname += `/${typeFilter}/${finalValue}`;
      } else {
        newUrl.searchParams.append(`filter[${typeFilter}]`, finalValue);
      }
    });

    return newUrl.toString();
  });

  return decodeURI(newUrl.toString());
};

export default checkbox;
